import React from "react";
import "./App.css";
import Dolls from "./components/shopDolls";

function App() {
  return (
    <div className="App">
      <Dolls />
    </div>
  );
}

export default App;
